<template>
	<div id="index" ref="appRef">
		<div class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body" id="pushbtnbox">
				<Header @getTime="getTime"/>
				<div class="pushbtn" style=" position: absolute;top:0.84rem;left:57%">
					<el-button type="primary" v-if="!inpause" @click="pocBtn">暂停</el-button>
					<el-button type="primary" v-if="inpause" @click="pocBtn">继续</el-button>
				</div>
				<div class="delta">
					<div class="delta_map">
						<deltaMap ref="map"/>
					</div>
					<div class="delta_chart">
						<div class="delta_top">
							<top-left ref="topLeftData"/>
							<top-right ref="topRightData"/>
						</div>
						<div class="delta_bottom">
							<bottom-left ref="bottomLeftData"/>
							<bottom-center ref="bottomCenterData"/>
							<bottom-right ref="bottomRightData" />
						</div>
					</div>
				</div>
			</div>
		
		</div>
	</div>
</template>
<script>
	import "@/assets/scss/delta.scss";
	import drawMixin from "../utils/drawMixin";
	import Header from './header'
	import deltaMap from './delta/map.vue'
	import topLeft from './delta/top-left.vue'
	import topRight from './delta/top-right.vue'
	import bottomLeft from './delta/bottom-left.vue';
	import BottomCenter from './delta/bottom-center.vue';
	import BottomRight from './delta/bottom-right.vue';
	import {getPageFiveData} from '@/utils/api.js'
	export default {
		mixins: [drawMixin],
		data() {
			return {
				loading:true, //加载状态
				timer:'', //定时器
				inpause:false, // 是否继续
			};
		},
		components: {
			Header,
			deltaMap,  
			topLeft,
			topRight,
			bottomLeft,
			BottomCenter,
			BottomRight
		},
		mounted() {
			this.timer = setTimeout(() =>{
				if(this && !this._isDestroyed){ //_isDestroyed 组件是否被销毁
					this.$router.push('/');
				}else{
					console.log(5,'已销毁')
				}
			},30000)
			this.cancelLoading();
			document.querySelector('body').setAttribute('style', 'background-color:#00296A;')
		},
		beforeDestroy() {
			document.querySelector('body').setAttribute('style', 'background-color:#020308;')
		},
		methods: {
			// 根据年月获取数据
			getTime(val){
				var params = {
					year:val.year,
					month:val.mon,
				}
				getPageFiveData(params).then(res=>{
					if(res.status == 200){
						this.$refs.map.getData(res.data.list1);
						var gkfmzlList = [], gkfmzfList = []
						var yxfmzlList = [],yxfmwrList = []
						var sqfmzfList = [],patentList = [],sqfmzlList = [],sqsyzlList = [],sqwgzlList = []
						var brandList = [],tmsqList = [],sqtmList = [],yxzctmList = []
						var pctzfList = [],pctsqList = []
						for(var i in res.data.list2){
							// 长三角地区发明专利公开情况
							gkfmzlList.push({
								id:res.data.list2[i].id,
								name:res.data.list2[i].city,
								value:res.data.list2[i].gkfmzl
							})
							gkfmzfList.push({
								id:res.data.list2[i].id,
								name:res.data.list2[i].city,
								value:res.data.list2[i].gkfmzf
							})
							// 长三角地区有效发明专利拥有情况
							yxfmzlList.push({
								id:res.data.list2[i].id,
								name:res.data.list2[i].city,
								value:res.data.list2[i].yxfmzl
							})
							yxfmwrList.push({
								id:res.data.list2[i].id,
								name:res.data.list2[i].city,
								value:res.data.list2[i].yxfmwr
							})
							// 长三角地区专利授权情况
							sqfmzfList.push({
								id:res.data.list2[i].id,
								name:res.data.list2[i].city,
								value:res.data.list2[i].sqfmzf
							})
							patentList.push({
								id:res.data.list2[i].id,
								name:res.data.list2[i].city,
							})
							sqfmzlList.push({
								value:res.data.list2[i].sqfmzl   // 发明专利
							})
							sqsyzlList.push({
								value:res.data.list2[i].sqsyzl	// 实用新型
							})
							sqwgzlList.push({
								value:res.data.list2[i].sqwgzl		// 外观
							})
							// 长三角地区商标数据(季度)
							brandList.push({
								id:res.data.list2[i].id,
								name:res.data.list2[i].city,
							})
							tmsqList.push({
								value:res.data.list2[i].tmsq
							})
							sqtmList.push({
								value:res.data.list2[i].sqtm
							})
							yxzctmList.push({
								value:res.data.list2[i].yxzctm
							})
							// 长三角地区PCT专利申请量
							pctzfList.push({
								id:res.data.list2[i].id,
								name:res.data.list2[i].city,
								value:res.data.list2[i].pctzf
							})
							pctsqList.push({
								id:res.data.list2[i].id,
								name:res.data.list2[i].city,
								value:res.data.list2[i].pctsq
							})
						}
						patentList.sqfmzlList = sqfmzlList
						patentList.sqsyzlList = sqsyzlList
						patentList.sqwgzlList = sqwgzlList
						brandList.tmsqList = tmsqList
						brandList.sqtmList = sqtmList
						brandList.yxzctmList = yxzctmList
						this.$refs.topLeftData.getData(gkfmzlList,gkfmzfList);
						this.$refs.topRightData.getData(yxfmzlList,yxfmwrList);
						this.$refs.bottomLeftData.getData(sqfmzfList,patentList);
						this.$refs.bottomCenterData.getData(brandList);
						this.$refs.bottomRightData.getData(pctzfList,pctsqList);
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			cancelLoading() {
				setTimeout(() => {
					this.loading = false;
					// setTimeout(() =>{
					// 	this.$router.push('/');
					// },60000)
				}, 500);
			},			
			pocBtn(){
				this.inpause = !this.inpause;
				console.log(this.inpause)
				if(this.inpause){
					console.log("cleartimeout")
					clearTimeout(this.timer);
				}else{
					this.timer = setTimeout(() =>{
						if(this && !this._isDestroyed){ //_isDestroyed 组件是否被销毁
							this.$router.push('/');
						}else{
							console.log(2,'已销毁')
						}
					},30000)
				}
			}
		},
	};
</script>
<style lang="scss" scoped>
	.bg {
		background-image: url("../assets/one.jpg");
	}
</style>

